import { Fragment } from 'react'

import OrganizationsFilter from '../../../Shared/Filters/OrganizationsFilter'
import SitesFilter from '../../../Shared/Filters/SitesFilter'

const PlanFilter = ({ state, dispatchState }) => {
  return (
    <Fragment>
      <OrganizationsFilter state={state} dispatchState={dispatchState} />
      <SitesFilter state={state} dispatchState={dispatchState} />
    </Fragment>
  )
}

export default PlanFilter
